import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "w-full py-8 px-6 mx-auto",
  style: {"min-height":"calc(100vh - 12rem)"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardContentHeader = _resolveComponent("DashboardContentHeader")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createVNode(_component_DashboardContentHeader, {
      heading: _ctx.heading,
      subheading: _ctx.subheading,
      "has-period-picker": _ctx.hasPeriodPicker,
      "has-pig-type-picker": _ctx.hasPigTypePicker,
      "slim-pig-type-picker": _ctx.slimPigTypePicker
    }, _createSlots({
      "top-right": _withCtx(() => [
        _renderSlot(_ctx.$slots, "header-top-right")
      ]),
      _: 2
    }, [
      (_ctx.$slots['above-heading'])
        ? {
            name: "above-heading",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "above-heading")
            ]),
            key: "0"
          }
        : undefined,
      (_ctx.$slots.subheading)
        ? {
            name: "subheading",
            fn: _withCtx(() => [
              _renderSlot(_ctx.$slots, "subheading")
            ]),
            key: "1"
          }
        : undefined
    ]), 1032, ["heading", "subheading", "has-period-picker", "has-pig-type-picker", "slim-pig-type-picker"]),
    _renderSlot(_ctx.$slots, "default")
  ]))
}